import { Module } from "vuex";
import { User } from "@/shared/model/user-management/user.model";
import { Client } from "@/shared/model/client.model";
import { WayneTutoStep } from "@/shared/model/chatbot/wayne-tuto-step.model";

export const dashboardStore: Module<any, any> = {
  state: {
    showAlert: {
      display: false,
      text: "",
      type: "",
    },
    retrieveData: false,
    multipleSends: null,
    navigateTo: null,
    accountTab: null,
    offer: null,
    constants: {
      o2sStartDate: null,
      earlybirdLimit: null,
      backOfficeUrl: null,
      profileUrl: null,
      chatbotUrl: null,
    },
    user: new User(),
    dashboardFilters: null,
    franchiseeFilters: null,
    importedContacts: null,
    contactsFile: null,
    statusFilters: null,
    roleFilters: null,
    advisorFilters: null,
    scoreFilters: null,
    interestFilters: null,
    typeFilters: null,
    sort: null,
    direction: null,
    sortActive: false,
    accountStartTab: "profile",
    popup: {
      opened: false,
      type: null,
      gameType: null,
    },
    infoDiv: {
      message: null,
      status: null,
    },
    announcement: null,
    goToReportDashboard: null,
    expendOnlyOneClient: null,
    collapseClient: null,
    reloadClient: null,
    resetReportDashboard: null,
    reloadReportDashboard: null,
    reloadFranchisorDashboard:null,
    deleteReportDashboard: null,
    includedComments: [],
    hoverFacettesCarrousel: false,
    listClientsToAssign: [],
    advisorToAssign: Client,
    changesInMyStructure: null, // update my structure page when user edited, added or deleted
    newAdvisorTooltip: null, //display tooltip when a new advisor is created for the first time
    botPanelOpen: false,
    selectedRecommendedQuestions: [],
    botTouchActions: [],
    clientsList: [],
    actionTargetClientId: null,
    activeBotAction: null,
    wayneFullscreenMode: false,
    mainMenuOpen: true,
    discussionClientId: null,
    botHistory: null,
    prospectToConvert: Client,
    reportDashboardIdFromProspect: null,

    wayneTutoSteps: [
      {
        title: "Découvrez les fonctionnalités de Wayne",
        description: "L'assitant Wayne est boosté grâce à l'IA, ainsi il peut répondre à toutes vos questions !",
        substeps: [
            {
                id: "step1-1",
                name: "write-question",
                description: "Écrire une question dans le champ ci-dessous",
                completed: false,
            },
            {
              id: "step1-2",
              name: "send-question",
              description: 'Envoyer la question avec ENTREE ou le bouton "Envoyer"',
              completed: false,
            },
        ],
        stepElId : "wayne-tuto-step-1",
        anchorTargetId: "text-input",
        tutoContElId: "wayne-tuto-cont-1",
        anchorPositionX: "above",
        anchorPositionY: "left",
        offsetX: 0,
        offsetY: -14,
        beforeShowStepDelayMs: 500,
      },
      {
        title: "Changer de discussion",
        description: "Une fois que vous avez fini votre discussion actuelle, fermez cette discussion pour en commencer une nouvelle.",
        substeps: [
            {
                id: "step2-1",
                name: "close-discussion",
                description: "Fermer la discussion existante",
                completed: false,
            },
        ],
        stepElId : "wayne-tuto-step-2",
        anchorTargetId: "close-discussion-btn",
        tutoContElId: "wayne-tuto-cont-1",
        anchorPositionX: "below",
        anchorPositionY: "left",
        offsetX: -20,
        offsetY: 14,
        beforeShowStepDelayMs: 3000,
      },
      {
        title: "Mentionner un client",
        description: "Pour tirer profit de la pleine puissance de Wayne, vous pouvez lui poser des questions recommandées prennant en compte les données de vos clients ayant complété leur quizz Odona360.",
        substeps: [
            {
                id: "step3-1",
                name: "add-mentionned-client",
                description: 'Cliquer sur le bouton "Ajouter un client concerné"',
                completed: false,
            },
            {
              id: "step3-2",
              name: "select-client",
              description: "Sélectionner un client dont vous souhaitez parler",
              completed: false,
            },
            {
              id: "step3-3",
              name: "use-action",
              description: "Sélectionner une action recommandée ou envoyer une question personnalisée",
              completed: false,
            },
        ],
        stepElId : "wayne-tuto-step-3",
        anchorTargetId: "mention-info-cont",
        tutoContElId: "wayne-tuto-cont-1",
        anchorPositionX: "above",
        anchorPositionY: "left",
        offsetX: -20,
        offsetY: -6,
        beforeShowStepDelayMs: 300,
      },
      {
        title: "Félicitations !",
        description: 'Vous avez appris les fonctionnalités principales de Wayne ! N\'hésitez pas à utiliser le bouton "Donner mon avis" pour nous transmettre vos questions et retours. Bonne utilisation !',
        substeps: [
        ],
        stepElId : "wayne-tuto-step-4",
        anchorTargetId: "wayne-chat-container",
        tutoContElId: "wayne-tuto-cont-1",
        anchorPositionX: "center",
        anchorPositionY: "left",
        offsetX: 0,
        offsetY: -14,
        beforeShowStepDelayMs: 1000,
      },
    ] as WayneTutoStep[],

    currentWayneTutoStepId: 0,
    wayneTutoRecalculateCount: 0,
  },

  // store.commit
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    showAlert(state, showAlert) {
      state.showAlert = showAlert;
    },

    togglePopup(state, popup) {
      if (!popup) {
        state.popup.opened = false;
        state.popup.type = null;
        state.popup.gameType = null;
      } else {
        state.popup = popup;
      }
    },
    toggleInfoDiv(state, message) {
      if (!message) {
        state.infoDiv.message = null;
        state.infoDiv.status = null;
      } else {
        state.infoDiv.message = message.message;
        state.infoDiv.status = message.status;
        if (message.delay) {
          setTimeout(() => {
            state.infoDiv.message = null;
            state.infoDiv.status = null;
          }, message.delay);
        }
      }
    },
    retrieveData(state, status) {
      state.retrieveData = status;
    },
    goToReportDashboard(state, report) {
      state.goToReportDashboard = report;
    },
    resetReportDashboard(state, bool) {
      state.resetReportDashboard = bool;
    },
    deleteReportDashboard(state, bool) {
      state.deleteReportDashboard = bool;
    },
    reloadReportDashboard(state, bool) {
      state.reloadReportDashboard = bool;
    },
    reloadFranchisorDashboard(state, bool){
      state.reloadFranchisorDashboard = bool;
    },
    reloadClient(state, bool) {
      state.reloadClient = bool;
    },
    setDashboardFilters(state, filters) {
      state.dashboardFilters = filters;
    },
    setFranchiseeFilters(state, filters) {
      state.franchiseeFilters = filters;
    },
    setImportedContacts(state, importedContacts) {
      state.importedContacts = importedContacts;
    },
    setContactsFile(state, contactsFile) {
      state.contactsFile = contactsFile;
    },
    setMultipleSends(state, sends) {
      state.multipleSends = sends;
    },
    setYmlConstants(state, constants) {
      state.constants = constants;
    },
    navigateTo(state, to) {
      state.navigateTo = to;
    },
    setAccountTab(state, tab) {
      state.accountTab = tab;
    },
    setScoreFilters(state, filters) {
      state.scoreFilters = filters;
    },
    setStatusFilters(state, filters) {
      state.statusFilters = filters;
    },
    setRoleFilters(state, filters) {
      state.roleFilters = filters;
    },
    setAdvisorFilters(state, filters) {
      state.advisorFilters = filters;
    },
    setInterestFilters(state, filters) {
      state.interestFilters = filters;
    },
    setTypeFilters(state, filters) {
      state.typeFilters = filters;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setDirection(state, direction) {
      state.direction = direction;
    },
    setSortActive(state, sortActive) {
      state.sortActive = sortActive;
    },
    setConvertedO2s(state, converted) {
      state.convertedO2s = converted;
    },
    setOffer(state, offer) {
      state.offer = offer;
    },
    setAccountStartTab(state, accountStartTab) {
      state.accountStartTab = accountStartTab;
    },
    setAnnouncement(state, announcement) {
      state.announcement = announcement;
    },
    expendOnlyOneClient(state, client) {
      state.expendOnlyOneClient = client;
    },
    collapseClient(state, boolean) {
      state.collapseClient = boolean;
    },
    setIncludedComments(state, comments) {
      state.includedComments = comments;
    },
    hoverFacettesCarrousel(state, bool) {
      state.hoverFacettesCarrousel = bool;
    },
    changesInMyStructure(state, changes) {
      state.changesInMyStructure = changes;
    },
    listClientsToAssign(state, clients) {
      state.listClientsToAssign = clients;
    },
    advisorToAssign(state, client) {
      state.advisorToAssign = client;
    },
    newAdvisorTooltip(state, idAdvisor) {
      state.newAdvisorTooltip = idAdvisor;
    },
    changeBotPanelState(state, botPanelOpen) {
      state.botPanelOpen = botPanelOpen;
    },
    selectBotRecommendedQuestion(state, recommendedQuestions) {
      state.selectedRecommendedQuestions = recommendedQuestions;
    },
    setBotTouchActions(state, touchActions) {
      state.botTouchActions = touchActions;
    },
    setClientsList(state, clientsList) {
      state.clientsList = clientsList;
    },
    setActionTargetClientId(state, clientId) {
      state.actionTargetClientId = clientId;
    },
    setActiveBotAction(state, action) {
      state.activeBotAction = action;
    },
    setWayneFullscreenMode(state, mode) {
      state.wayneFullscreenMode = mode;
    },
    setMainMenuState(state, isOpen) {
      state.mainMenuOpen = isOpen;
    },
    setDiscussionClientId(state, clientId) {
      state.discussionClientId = clientId;
    },
    setBotHistory(state, history) {
      state.botHistory = history;
    },
    setReportDashboardIdFromProspect(state, reportId) {
      state.reportDashboardIdFromProspect = reportId;
    },
    setProspectToConvert(state, prospect) {
      state.prospectToConvert = prospect;
    },
    setWayneStepStatus(state, stepModifier) {
      let targetSubstep;
      console.log("IN MODIFIER!!!", stepModifier.isCompleted);
      const targetStep = state.wayneTutoSteps.find(step => step.substeps.some((substep) => {
          if (substep.name != stepModifier.substepName) {
            return false;
          }
          targetSubstep = substep;
          return true;
        }
      ));

      console.log("TARGET SUBSTEP", targetSubstep);
      if (targetStep == undefined || targetStep == null || targetSubstep == null) {
        console.warn("TRYING TO ACCESS INEXISTANT WAYNE TUTO STEP : " + stepModifier.substepName);
        return;
      }

      targetSubstep.completed = stepModifier.isCompleted;
      console.log("TARGET SUBSTEP", targetSubstep);
      console.log("STEP MODIFIER STATUS", stepModifier.isCompleted);
      state.wayneTutoSteps = [...state.wayneTutoSteps];
    },

    wayneTutoNextStep(state) {
      if (state.wayneTutoSteps.length > state.currentWayneTutoStepId+1) {
        state.currentWayneTutoStepId += 1;
      }
    },

    recalculateWayneTutoPosition(state) {
      // We don't actually need a value, but to watch each time we want to 
      // recalculate, watching an integer value change is one of the easiest ways
      state.wayneTutoRecalculateCount += 1;
    },
    setWayneTutoStepId(state, stepId) {
      state.currentWayneTutoStepId = stepId;
    },
    setWayneTutoSteps(state, steps) {
      state.wayneTutoSteps = steps;
    }
  },

  getters: {
    user: (state) => state.user,
    showAlert: (state) => state.user,
    popup: (state) => state.popup,
    infoDiv: (state) => state.infoDiv,
    retrieveData: (state) => state.retrieveData,
    dashboardFilters: (state) => state.dashboardFilters,
    franchiseeFilters: (state) => state.franchiseeFilters,
    importedContacts: (state) => state.importedContacts,
    contactsFile: (state) => state.contactsFile,
    multipleSends: (state) => state.multipleSends,
    navigateTo: (state) => state.navigateTo,
    accountTab: (state) => state.accountTab,
    goToReportDashboard: (state) => state.goToReportDashboard,
    resetReportDashboard: (state) => state.resetReportDashboard,
    deleteReportDashboard: (state) => state.deleteReportDashboard,
    reloadReportDashboard: (state) => state.reloadReportDashboard,
    reloadFranchisorDashboard: (state) => state.reloadFranchisorDashboard,
    reloadClient: (state) => state.reloadClient,
    statusFilters: (state) => state.statusFilters,
    roleFilters: (state) => state.roleFilters,
    advisorFilters: (state) => state.advisorFilters,
    scoreFilters: (state) => state.scoreFilters,
    interestFilters: (state) => state.interestFilters,
    typeFilters: (state) => state.typeFilters,
    sort: (state) => state.sort,
    direction: (state) => state.direction,
    sortActive: (state) => state.sortActive,
    convertedO2s: (state) => state.convertedO2s,
    offer: (state) => state.offer,
    accountStartTab: (state) => state.accountStartTab,
    o2sStartDate: (state) => state.constants.o2sStartDate,
    earlybirdLimit: (state) => state.constants.earlybirdLimit,
    backOfficeUrl: (state) => state.constants.backOfficeUrl,
    profileUrl: (state) => state.constants.profileUrl,
    chatbotUrl: (state) => state.constants.chatbotUrl,
    announcement: (state) => state.announcement,
    expendOnlyOneClient: (state) => state.expendOnlyOneClient,
    collapseClient: (state) => state.collapseClient,
    includedComments: (state) => state.includedComments,
    hoverFacettesCarrousel: (state) => state.hoverFacettesCarrousel,
    changesInMyStructure: (state) => state.changesInMyStructure,
    listClientsToAssign: (state) => state.listClientsToAssign,
    advisorToAssign: (state) => state.advisorToAssign,
    newAdvisorTooltip: (state) => state.newAdvisorTooltip,
    botPanelOpen: (state) => state.botPanelOpen,
    selectedRecommendedQuestions: (state) => state.selectedRecommendedQuestions,
    botTouchActions: (state) => state.botTouchActions,
    clientsList: (state) => state.clientsList,
    actionTargetClientId: (state) => state.actionTargetClientId,
    activeBotAction: (state) => state.activeBotAction,
    wayneFullscreenMode: (state) => state.wayneFullscreenMode,
    mainMenuOpen: (state) => state.mainMenuOpen,
    discussionClientId: (state) => state.discussionClientId,
    botHistory: (state) => state.botHistory,
    reportDashboardIdFromProspect: (state) => state.reportDashboardIdFromProspect,
    prospectToConvert: (state) => state.prospectToConvert,
    wayneTutoSteps: (state) => state.wayneTutoSteps,
    currentWayneTutoStepId: (state) => state.currentWayneTutoStepId,
    currentWayneTutoStep: (state) => state.wayneTutoSteps[state.currentWayneTutoStepId],
    onRecalculateWayneTutoPosition: (state) => state.wayneTutoRecalculateCount,
  },
};
